import { render } from "./index.vue?vue&type=template&id=0aab4d88&bindings={}"
import script from "./action-label.js?vue&type=script&lang=js"
export * from "./action-label.js?vue&type=script&lang=js"

import "./action-label.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script